import React, { Component, Fragment, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addBasket } from "../../redux/reducers/basket";
import { getProductTotalPrice } from "../../utils/commons";
import _ from "lodash";

const QuickviewOptions = (props) => {
	const basket = useSelector((state) => state.basket);
	const optionLists = useSelector((state) => state.restaurant.optionLists);
	const dispatch = useDispatch();
	const isAddingToCart = useRef(false);
	const [state, setState] = useState({
		quantity: 1,
		currentProduct: Object.assign({}, props.product),
		selectedOptions: {},
		totalPrice: props.product.price,
	});

	const IncrementItem = () => {
		state.currentProduct.quantity += 1;
		setState({ ...state });
	};

	const DecreaseItem = () => {
		if (state.currentProduct.quantity < 1) {
			state.currentProduct.quantity = 0;
			setState({ ...state, quantity: 0 });
		} else {
			state.currentProduct.quantity -= 1;
			setState({ ...state, quantity: state.quantity - 1 });
		}
	};
	const handleChange = (event) => {
		state.currentProduct.quantity = event.target.value;
		setState({ ...state });
	};

	useEffect(() => {
		let selectedOptions = props.content ? _.cloneDeep(props.content) : {};
		state.currentProduct.quantity = 1;
		if (!props.content) {
			state.currentProduct.optionLists.forEach((ol) => {
				const olOptions = optionLists.find(
					(olist) => olist.optionListId == ol.optionListId
				).options;

				if (olOptions.find((o) => o.default)) {
					selectedOptions[ol.optionListId] = olOptions
						.filter((o) => o.default)
						.map((o) => {
							return { ...o, quantity: 1 };
						});
				}
			});
		}

		const totalPrice = getProductTotalPrice(
			props.product.price,
			props.product,
			selectedOptions
		);
		setState({ ...state, selectedOptions, totalPrice });
	}, []);

	const onSelected = (optionList, option) => {
		const currOList = optionLists.find(
			(ol) => ol.optionListId == optionList.optionListId
		);

		// add item and price to totalPrice on first press, deletes from and substract from totalPrice on 2nd
		let selectedOptions = { ...state.selectedOptions };
		if (!selectedOptions[optionList.optionListId]) {
			selectedOptions[optionList.optionListId] = [];
		}

		let currentOptions = selectedOptions[optionList.optionListId] || [];
		let min = optionList.minChoices;
		let max =
			optionList.maxChoices && !optionList.supplementAfterMaxAllowed
				? optionList.maxChoices
				: 0;

		// let selectedOptions = [...state.selectedOptions];
		// let max =
		// 	currentItem.nbOptionsAllowed &&
		// 	!currentItem.supplementOptionAfterMaxAllowed
		// 		? currentItem.nbOptionsAllowed
		// 		: 0;

		let uniqueProduct = currOList.options.find(
			(elt) => elt.unique || elt.uniqueInPart
		);

		const uniqueProductIndex = currentOptions.findIndex(
			(elt) => uniqueProduct && elt.optionId == uniqueProduct.optionId
		);

		const hasUniqueSelected = uniqueProduct && uniqueProductIndex !== -1;

		const foundIndex = currentOptions.findIndex(
			(elt) => elt.optionId == option.optionId
		);
		let nbOptions = getNbItemsInPart(currentOptions);

		const nOption = {
			...option,
			quantity: 1,
			order: optionList.optionListOrder,
		};

		const isUnique = option.unique || option.uniqueInPart;

		if (foundIndex > -1) {
			currentOptions.splice(foundIndex, 1);
		} else if (isUnique) {
			currentOptions = [nOption];
		} else if (max && nbOptions == max) {
			currentOptions[0] = nOption;
		} else {
			if (hasUniqueSelected) {
				currentOptions.splice(uniqueProductIndex, 1);
			}
			currentOptions.push(nOption);
		}

		console.log({ optionList, nOption });

		selectedOptions[optionList.optionListId] = [...currentOptions];

		nbOptions = getNbItemsInPart(currentOptions);

		const totalPrice = getProductTotalPrice(
			state.currentProduct.price,
			state.currentProduct,
			selectedOptions
		);

		setState({ ...state, selectedOptions: selectedOptions, totalPrice });
	};

	const addQuantity = (optionList, option) => {
		let max =
			optionList.maxChoices && !optionList.supplementAfterMaxAllowed
				? optionList.maxChoices
				: 0;
		let selectedOptions = state.selectedOptions;

		let nbOptions = getNbItemsInPart(selectedOptions[option.optionListId]);

		if (max && nbOptions == max && !optionList.supplementAfterMaxAllowed) {
			return;
		}
		let foundIndex = selectedOptions[option.optionListId].findIndex(
			(elt) => elt.optionId == option.optionId
		);

		selectedOptions[option.optionListId][foundIndex].quantity += 1;

		const totalPrice = getProductTotalPrice(
			state.currentProduct.price,
			state.currentProduct,
			selectedOptions
		);

		setState({ ...state, selectedOptions, totalPrice });
	};

	const removeQuantity = (option) => {
		let selectedOptions = state.selectedOptions;
		let foundIndex = selectedOptions[option.optionListId].findIndex(
			(elt) => elt.optionId == option.optionId
		);
		selectedOptions[option.optionListId][foundIndex].quantity -= 1;

		if (selectedOptions[option.optionListId][foundIndex].quantity == 0) {
			selectedOptions[option.optionListId].splice(foundIndex, 1);
		}
		const totalPrice = getProductTotalPrice(
			state.currentProduct.price,
			state.currentProduct,
			selectedOptions
		);
		setState({ ...state, selectedOptions, totalPrice });
	};

	const getNbItemsInPart = (productOptions) => {
		return productOptions
			? productOptions.reduce((acc, curr) => (acc += curr.quantity), 0)
			: 0;
	};

	// const canAddToBasket = () => {
	// 	// user can only add to cart when he selected at least all the mandatory sections, with the right number of items
	// 	let bool = true;
	// 	if (state.currentProduct.options) {
	// 		state.currentProduct.options.map((opt, index) => {
	// 			if (state.currentProduct.optionMandatory) {
	// 				let nbOptions = getNbItemsInPart(state.selectedOptions);
	// 				if (nbOptions < state.currentProduct.nbOptionsAllowed) {
	// 					bool = false;
	// 				}
	// 			}
	// 		});
	// 	}

	// 	return bool;
	// };

	const canAddToBasket = () => {
		// user can only add to cart when he selected at least all the mandatory sections, with the right number of items
		let bool = true;
		state.currentProduct.optionLists.map((oList, index) => {
			if (oList.minChoices > 0) {
				let nbOptions = getNbItemsInPart(
					state.selectedOptions[oList.optionListId]
				);
				console.log(oList.name, { nbOptions });
				if (nbOptions < oList.minChoices) {
					bool = false;
				}
			}
		});

		return bool;
	};

	const addToCart = () => {
		if (!isAddingToCart.current) {
			let item = { ...state.currentProduct };
			item.content = state.selectedOptions;
			item.selectedOptions = Object.values(state.selectedOptions).reduce(
				(acc, items) => {
					acc.push(...items);
					return acc;
				},
				[]
			);

			props.addItemToCart(item, null, true);
		}
	};

	// const addItemToCart = (itemToAdd, fromOptionModal = false) => {
	// 	isAddingToCart.current = false;
	// 	itemToAdd.productPrice = itemToAdd.price;
	// 	let item = { ...itemToAdd };
	// 	item.quantity = 1;
	// 	if (props.mode == "takeAway" && item.priceTakeAway) {
	// 		item.price = item.priceTakeAway;
	// 	}

	// 	item.price = getProductTotalPrice(
	// 		item.price,
	// 		item,
	// 		itemToAdd.selectedOptions
	// 	);

	// 	item.status = "pending";
	// 	item.type = "product";
	// 	item.printed = false;
	// 	item.basePrice = item.price;
	// 	item.discountAmount = 0;

	// 	dispatch(addBasket(item));

	// 	props.onHide();
	// };

	return (
		<>
			<Modal.Header
				className="modal-bg"
				closeButton
				style={{
					padding: "20px 0",
				}}
			>
				<div
					className="close-btn cart-trigger close-dark"
					onClick={() => props.onHide()}
				>
					<span />
					<span />
				</div>
			</Modal.Header>
			<Modal.Body>
				<div className="customize-meta">
					<h4 className="customize-title">
						{state.currentProduct.name}{" "}
						<span className="custom-primary">
							{parseFloat(state.currentProduct.price).toFixed(2)} €
						</span>{" "}
					</h4>
					<p>{state.currentProduct.description}</p>
				</div>
				<div className="customize-variations">
					{/* <div className='customize-size-wrapper'>
									<h5>Size: </h5>
									{state.currentProduct.sizes.map((item, i) => (
										<div
											key={i}
											className={
												state.currentProduct.state
													? "customize-size active"
													: "customize-size"
											}
										>
											{state.currentProduct.size}"
										</div>
									))}
								</div> */}
					<div className="row">
						{/* Variation Start */}

						{state.currentProduct.optionLists.map((optionList, index) => {
							const currOList = optionLists.find(
								(ol) => ol.optionListId == optionList.optionListId
							);

							return (
								<div
									key={index}
									className={
										"col-12 " +
										(state.currentProduct.optionLists.length > 1
											? "col-md-6"
											: "")
									}
								>
									<div className="customize-variation-wrapper">
										<h5
											className={
												"menu-part-title" +
												(optionList.minChoices > 0 ? " mandatory" : "")
											}
										>
											{optionList.displayName || optionList.name}
											<span className="menu-part-subtitle">
												{optionList.minChoices > 0
													? "Obligatoire - " +
													  optionList.maxChoices +
													  " au choix"
													: ""}
											</span>
										</h5>
										{currOList.options
											.filter(
												(option) =>
													!option.servicesAvailability ||
													option.servicesAvailability.includes(basket.mode)
											)
											.map((option, i) => {
												const isSelected = state.selectedOptions[
													optionList.optionListId
												]
													? state.selectedOptions[optionList.optionListId].find(
															(elt) => elt.optionId == option.optionId
													  )
													: null;
												const nbOptions = getNbItemsInPart(
													state.selectedOptions[optionList.optionListId]
												);

												const showPrice =
													option.price > 0 &&
													(!isSelected ||
														isSelected.supplementAfterMaxAllowed ||
														isSelected.supplement);

												return (
													<div key={i} className="customize-variation-item">
														<div
															className={
																"custom-control custom-" +
																(optionList.minChoices > 0 &&
																optionList.maxChoices == 1
																	? "radio"
																	: "checkbox")
															}
															style={{ display: "flex" }}
														>
															<input
																type={
																	optionList.minChoices > 0 &&
																	optionList.maxChoices == 1
																		? "radio"
																		: "checkbox"
																}
																name={"option-" + option.optionId}
																id={"product-" + option.optionId}
																className="custom-control-input"
																checked={isSelected ? true : false}
																onChange={(event) => {
																	onSelected(optionList, option);
																}}
															/>
															<label
																className="custom-control-label"
																htmlFor={"product-" + option.optionId}
															>
																{option.name}
															</label>
														</div>
														{isSelected &&
														optionList.enableQuantity &&
														(optionList.maxChoices > 1 ||
															(optionList.maxChoices == 1 &&
																optionList.supplementAfterMaxAllowed)) ? (
															<div className="qty">
																<span
																	className="qty-subtract"
																	onClick={() => removeQuantity(option)}
																>
																	<i className="fa fa-minus" />
																</span>
																<input
																	type="text"
																	name="qty"
																	value={isSelected ? isSelected.quantity : 0}
																	readOnly
																/>
																<span
																	className="qty-add"
																	onClick={() =>
																		addQuantity(optionList, option)
																	}
																>
																	<i className="fa fa-plus" />
																</span>
															</div>
														) : null}
														{option.disabled ? (
															<span style={{ fontSize: 11, color: "#B22222" }}>
																INDISPONIBLE
															</span>
														) : option.price > 0 &&
														  (option.supplement ||
																(optionList.supplementAfterMaxAllowed &&
																	nbOptions >= optionList.maxChoices)) &&
														  showPrice ? (
															<span>
																+ {parseFloat(option.price).toFixed(2)} €
															</span>
														) : null}
													</div>
												);
											})}
									</div>
								</div>
							);
						})}
						{/* Variation End */}
					</div>
				</div>

				<div
					className={
						"customize-controls " +
						(props.inMenu ? "justify-content-center" : "")
					}
				>
					{!props.inMenu && (
						<div className="qty">
							<span className="qty-subtract" onClick={DecreaseItem}>
								<i className="fa fa-minus" />
							</span>
							<input
								type="text"
								name="clicks"
								value={state.currentProduct.quantity || 1}
								onChange={(e) => handleChange(e)}
							/>
							<span className="qty-add" onClick={IncrementItem}>
								<i className="fa fa-plus" />
							</span>
						</div>
					)}
					<div
						className="customize-total"
						data-price={parseFloat(state.currentProduct.price).toFixed(2)}
					>
						<h5>
							Total :{" "}
							<span className="final-price custom-primary">
								{parseFloat(state.totalPrice).toFixed(2)} <span>€</span>{" "}
							</span>{" "}
						</h5>
					</div>
				</div>
				<button
					type="button"
					className="btn-custom btn-block"
					disabled={!canAddToBasket()}
					onClick={() => addToCart()}
					style={{ bacgroundColor: "blue" }}
				>
					Commander
				</button>
			</Modal.Body>
		</>
	);
};

export default QuickviewOptions;
